/* GENERATED FROM policyReader.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'
import * as commonHdr from './commonHdr.service'
import * as policyReaderGCP from './policyReaderGCP.service'

export class PolicyReader {
  static ValidateOrganization = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<
    ValidateOrganizationReq,
    {},
    ValidateOrganizationResp
  >): Promise<APIResponse<ValidateOrganizationResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/policy-reader/test-connection`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ValidateOrganizationResp>>()
          .then<APIResponse<ValidateOrganizationResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetResourceTypeEnum = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetResourceTypeEnumReq, {}, GetResourceTypeEnumResp>): Promise<
    APIResponse<GetResourceTypeEnumResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/policy-reader/supported-resource-types`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetResourceTypeEnumResp>>()
          .then<APIResponse<GetResourceTypeEnumResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetPolicies = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetPoliciesReq, {}, GetPoliciesResp>): Promise<
    APIResponse<GetPoliciesResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/policy-reader/policies`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetPoliciesResp>>()
          .then<APIResponse<GetPoliciesResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static BuildOrganizationHierarchy = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<
    BuildOrganizationHierarchyReq,
    {},
    BuildOrganizationHierachyResp
  >): Promise<APIResponse<BuildOrganizationHierachyResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/policy-reader/build-organization-hierarchy`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<BuildOrganizationHierachyResp>>()
          .then<APIResponse<BuildOrganizationHierachyResp>>(
            preProcessingResponse
          )
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetOrganizationHierarchy = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<
    GetOrganizationHierarchyReq,
    {},
    GetOrganizationHierarchyResp
  >): Promise<APIResponse<GetOrganizationHierarchyResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/policy-reader/get-organization-hierarchy`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetOrganizationHierarchyResp>>()
          .then<APIResponse<GetOrganizationHierarchyResp>>(
            preProcessingResponse
          )
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface UserAssignedIdentities {
  principal_id?: string
  client_id?: string
}

export interface AccountDataInfo {
  Id?: string
  ResourceType?: string
  cannonical_user_id?: string
  resource_stats?: AccountDataInfo_ResourceStatsEntry
  public_stats?: AccountDataInfo_PublicStatsEntry
  password_policy?: PasswordPolicy
  role_arn?: string
  external_id?: string
  cloud_type?: base.CloudTypeEnum
  display_name?: string
  enabled_regions?: string[]
}

export interface AccountDataInfo_ResourceStatsEntry {
  [key: string]: number
}

export interface AccountDataInfo_PublicStatsEntry {
  [key: string]: number
}

export interface PasswordPolicy {
  require_lowercase_characters?: boolean
  require_numbers?: boolean
  require_symbols?: boolean
  require_uppercase_characters?: boolean
  min_password_length?: string
  password_reuse_prevention?: string
  max_password_age?: string
}

export interface IAMInfo {
  common_info?: base.CommonInfo
  group_list?: string[]
  policy_list?: string[]
  assume_role_policy_document?: string
  policy_document?: string
  user_count?: number
  password_last_used?: string
  managed_policy?: string[]
  inline_policy?: string[]
  mfa_devices?: string
  virtual_mfa_devices?: string
  login_profile?: boolean
  access_keys?: AccessKey[]
  permissions?: base.permissions
  guest_user?: boolean
  display_name?: string
  cloud_specific_id?: string
  permissions_boundary_arn?: string
  default_policy?: boolean
  policies_count?: number
  saml_providers_docs?: string[]
  join_all_roles_flag?: boolean
  is_federated?: boolean
  enterprise_directory?: string
  scope_list?: IAMInfo_ScopeListEntry
}

export interface IAMInfo_ScopeListEntry {
  [key: string]: string
}

export interface IDPInfo {
  common_info?: base.CommonInfo
  entity_id?: string
  arn?: string
}

export interface AzureServicePrincipalInfo {
  common_info?: base.CommonInfo
  service_principal_type?: string
  app_display_name?: string
  service_principal_names?: string[]
  object_type?: string
  display_name?: string
  attached_vm_id?: string
}

export interface AccessKey {
  id?: string
  create_date?: string
  last_used?: string
  is_active?: boolean
}

export interface ADRoleInfo {
  Id?: string
  name?: string
  value?: string
}

export interface S3Info {
  common_info?: base.CommonInfo
  policy_list?: string[]
  object_count?: string
  kms_key_id_list?: string[]
  s3Acl?: string
  parent_profile?: string
  object_name?: string[]
  logging_enabled?: boolean
}

export interface KMSInfo {
  common_info?: base.CommonInfo
  policy_list?: string[]
  enabled?: boolean
  key_rotation_status?: boolean
}

export interface VpcInfo {
  common_info?: base.CommonInfo
  cidr_block?: string
  dhcp_options_id?: string
  instance_tenancy?: string
  is_default?: boolean
  state?: string
  cidr_block_association_set?: string
  ipv6_cidr_block_association_set?: string
  attached_gw?: boolean
  is_all_flow_logs_active?: boolean
}

export interface SgInfo {
  common_info?: base.CommonInfo
  description?: string
  ip_permissions?: string
  ip_permissions_egress?: string
  owner_id?: string
  vpc_id?: string
  is_default?: boolean
  common_sg_info?: commonHdr.CommonSGInfo
}

export interface NaclInfo {
  common_info?: base.CommonInfo
  vpc_id?: string
  is_default?: boolean
  associations?: string
  entries?: string
}

export interface OpenPorts {
  protocol?: string
  ports?: string[]
  direction?: DirectionEnum
  addresses?: string[]
  priority?: number
}

export interface InstanceInfo {
  common_info?: base.CommonInfo
  common_vm_info?: commonHdr.CommonVMInfo
  instance_type?: string
  key_name?: string
  instance_data?: string
  instance_roles?: string[]
  resource_id?: string
}

export interface VpcEndPointInfo {
  common_info?: base.CommonInfo
  vpc_id?: string
  service_name?: string
  policy_document?: string
  end_point_data?: string
}

export interface RDSInfo {
  common_info?: base.CommonInfo
  kms_key_id?: string
  public_risk?: boolean
  cluster_id?: string
  vpc_id?: string
  condition?: RDSInfo_ConditionEntry
  subnet_id?: string[]
  vpc_security_group?: string[]
}

export interface RDSInfo_ConditionEntry {
  [key: string]: string
}

export interface Attachment {
  instance_id?: string
  time?: string
  delete_on_termination?: boolean
  state?: string
}

export interface EBSInfo {
  common_info?: base.CommonInfo
  attachments?: Attachment[]
  volume_type?: string
  state?: string
  kms_key_id?: string
  snapshot_id?: string
}

export interface SubnetInfo {
  common_info?: base.CommonInfo
  subnet_data?: string
  route_table_id?: string
  nacl_id?: string
  vpc_id?: string
}

export interface RouteTableInfo {
  common_info?: base.CommonInfo
  route_table_data?: string
  igw?: string
  egress_only_gw?: string
  nat_gw?: string
  subnet_ids?: string[]
}

export interface PrefixListInfo {
  common_info?: base.CommonInfo
  prefix_id?: string
}

export interface SCPInfo {
  common_info?: base.CommonInfo
  policy_list?: string[]
  children_ids?: string[]
  org_node_type?: string
}

export interface LambdaInfo {
  common_info?: base.CommonInfo
  kms_key_id?: string
  role_id?: string
  security_group_ids?: string[]
  subnet_ids?: string[]
  vpc_id?: string
  function_arn?: string
  layers?: string[]
}

export interface AzureFunctionAppsInfo {
  common_info?: base.CommonInfo
  azure_fn_app_id?: string
  resource_group?: string
  host_names?: string[]
  enabled_host_names?: string[]
  outbound_ip_addresses?: string
  principal_ids?: string[]
}

export interface CloudWatchMetricInfo {
  common_info?: base.CommonInfo
  Id?: string
  name?: string
  filters?: CloudWatchMetricFilterInfo[]
  alarms?: CloudWatchMetricAlarm[]
}

export interface CloudWatchMetricFilterInfo {
  metric_name?: string
  filter_pattern?: string
  filter_name?: string
  log_group_name?: string
}

export interface CloudWatchMetricAlarm {
  name?: string
  actions?: string[]
}

export interface SNSTopicInfo {
  common_info?: base.CommonInfo
  Id?: string
  arn?: string
  subscriptions?: SNSSubscriptionInfo[]
}

export interface SNSSubscriptionInfo {
  arn?: string
}

export interface CloudTrailInfo {
  common_info?: base.CommonInfo
  kms_key_id?: string
  is_integrated_with_cloud_watch?: boolean
  log_file_validation_enabled?: boolean
  is_multi_regional?: boolean
  is_logging?: boolean
  event_selectors?: EventSelector[]
  s3_bucket_name?: string
  log_group_name?: string
}

export interface ConfigServiceInfo {
  common_info?: base.CommonInfo
  record_name?: string
  recordingGroup?: RecordingGroup
  status?: ConfigurationRecorderStatus
  region?: string
}

export interface RecordingGroup {
  all_supported?: boolean
  include_global_resource_types?: boolean
}

export interface ConfigurationRecorderStatus {
  recording?: boolean
  last_status?: string
}

export interface EventSelector {
  include_management_events?: boolean
  read_write_type?: string
}

export interface AthenaInfo {
  common_info?: base.CommonInfo
  Id?: string
  ResourceType?: string
}

export interface GlueInfo {
  common_info?: base.CommonInfo
  Id?: string
  ResourceType?: string
}

export interface SQSInfo {
  common_info?: base.CommonInfo
  Id?: string
  ResourceType?: string
}

export interface ElasticbeanstalkInfo {
  common_info?: base.CommonInfo
  Id?: string
  ResourceType?: string
}

export interface StorageAccountInfo {
  common_info?: base.CommonInfo
  object_count?: string
  parent_profile?: string
  object_name?: string[]
  resource_id?: string
  kind?: string
  blob_service_encryption_enabled?: boolean
  file_service_encryption_enabled?: boolean
  secure_transfer_enabled?: boolean
  name?: string
  file_service_encryption_last_enabled_time?: string
  blob_service_encryption_last_enabled_time?: string
  publicly_reachable?: boolean
  subnetURIs?: string[]
  encryption_properties?: EncryptionProperties
}

export interface EncryptionProperties {
  key_name?: string
  vault_name?: string
}

export interface StorageContainerInfo {
  common_info?: base.CommonInfo
  resource_id?: string
  public_risk?: boolean
  encryption_properties?: EncryptionProperties
}

export interface AzureKeyVaultKeyInfo {
  common_info?: base.CommonInfo
  expiration_date_set?: boolean
}

export interface AzureKeyVaultSecretInfo {
  common_info?: base.CommonInfo
  expiration_date_set?: boolean
}

export interface KeyVaultInfo {
  common_info?: base.CommonInfo
  resource_id?: string
  keyvault_keys?: string[]
  keyvault_secrets?: string[]
  logging_enabled?: boolean
  logging_retention_num_days?: number
  keyVaultInUse?: boolean
  policies?: KeyVaultPolicy[]
}

export interface KeyVaultPolicy {
  user_id?: string
  key_permissions?: string[]
  secret_permissions?: string[]
}

export interface FirewallRule {
  rule_id?: string
  start_ip?: string
  end_ip?: string
}

export interface RedisCacheInfo {
  common_info?: base.CommonInfo
  resource_id?: string
  subnet_id?: string
  enable_non_ssl_port?: boolean
  redis_configuration?: RedisCacheInfo_RedisConfigurationEntry
  static_ip?: string
  firewallrules?: FirewallRule[]
  linked_server_present?: boolean
}

export interface RedisCacheInfo_RedisConfigurationEntry {
  [key: string]: string
}

export interface RoleAssignmentInfo {
  common_info?: base.CommonInfo
  role_uri?: string
  principal_uri?: string
  permissions?: base.permissions
  scope?: string
  subscription_id?: string
  object_id_translation_needed?: boolean
}

export interface roleAssignmentPolicy {
  principal_name?: string
  role_name?: string
  actions?: string[]
  not_actions?: string[]
  role_assignment_id?: string
  role_assignment_name?: string
  scope?: string
}

export interface keyVaultAccessPolicy {
  azure_tenant_id?: string
  object_id?: string
  application_id?: string
  key_permissions?: string[]
  secret_permissions?: string[]
  certificate_permissions?: string[]
}

export interface azure_role_definition {
  role_name?: string
  permissions?: base.permissions
  role_type?: string
  assignable_scopes?: string[]
  role_id?: string
}

export interface VirtualNetworkInfo {
  common_info?: base.CommonInfo
  resource_id?: string
  address_prefixes?: string[]
  dhcp_options?: string[]
  subnet_ids?: string[]
  ddos_protection_enabled?: boolean
  vm_protection_enabled?: boolean
}

export interface AzureNICInfo {
  subnet_id?: string
  sg_id?: string[]
  public_ip_address?: string[]
  private_ip_address?: string[]
  vnet_id?: string
  network_interface_ids?: string[]
}

export interface AzureVMInfo {
  common_info?: base.CommonInfo
  common_vm_info?: commonHdr.CommonVMInfo
  instance_type?: string
  resource_id?: string
  os_disk_encryption_enabled?: boolean
  principal_ids?: string[]
  nic_info?: AzureNICInfo[]
  is_agent_installed?: boolean
  is_disks_encrypted?: boolean
}

export interface AzureDisksInfo {
  common_info?: base.CommonInfo
  Id?: string
  Name?: string
  ResourceId?: string
  ResourceType?: string
  disk_state?: string
  tags?: AzureDisksInfo_TagsEntry
  managed_by?: string
  encryption_properties?: EncryptionProperties[]
  native_id?: string
}

export interface AzureDisksInfo_TagsEntry {
  [key: string]: string
}

export interface AzureCosmosDBInfo {
  common_info?: base.CommonInfo
}

export interface AzureSubnetInfo {
  common_info?: base.CommonInfo
  resource_id?: string
  address_prefixes?: string[]
  network_security_group_id?: string
  route_table_id?: string
  vpc_id?: string
}

export interface AzureSecurityGroupInfo {
  common_info?: base.CommonInfo
  security_rules?: string
  network_interfaces?: string[]
  subnets?: string[]
  open_ports?: string
  flow_log_properties?: FlowLogProperties
  common_sg_info?: commonHdr.CommonSGInfo
}

export interface FlowLogProperties {
  enabled?: boolean
  retention_policy?: RetentionPolicy
}

export interface RetentionPolicy {
  enabled?: boolean
  days?: number
}

export interface AzureRouteTableInfo {
  common_info?: base.CommonInfo
  rt_info?: commonHdr.CommonRTInfo
  resource_id?: string
}

export interface AzureSQLFirewallRules {
  start_ip_address?: string
  end_ip_address?: string
  name?: string
}

export interface AzureSQLServerInfo {
  common_info?: base.CommonInfo
  public_risk?: boolean
  public_policy_name?: string
  expiry_set_for_all_keys?: boolean
  sql_db_ids?: string[]
  ad_admin_configured?: boolean
  replication_enabled?: boolean
  firewall_rules?: AzureSQLFirewallRules[]
  admin_login_configured?: boolean
  db_count?: number
}

export interface AzureSQLDatabaseInfo {
  common_info?: base.CommonInfo
  public_risk?: boolean
  public_policy_name?: string
  failover_group_configured?: boolean
  is_encrypted?: boolean
  sql_server_id?: string
  auditing_enabled?: boolean
  alert_email_configured?: boolean
  threat_detection_enabled?: boolean
  audit_retention_enabled?: boolean
  email_admin_enabled?: boolean
  audit_retention_days?: number
}

export interface ResourceGroupSecuritySettings {
  Name?: string
  security_center_policy_checks?: ResourceGroupSecuritySettings_SecurityCenterPolicyChecksEntry
  network_watcher_enabled?: boolean
  subscription_id?: string
}

export interface ResourceGroupSecuritySettings_SecurityCenterPolicyChecksEntry {
  [key: string]: boolean
}

export interface AzureSubscriptionSecuritySettingInfo {
  common_info?: base.CommonInfo
  log_profile_present?: boolean
  log_profile_log_retention_365_days?: boolean
  security_center_autoprovision_settings_enabled?: boolean
  security_center_standard_pricing_tier_enabled?: boolean
  resource_group_settings?: AzureSubscriptionSecuritySettingInfo_ResourceGroupSettingsEntry
  activity_log_alerts?: AzureSubscriptionSecuritySettingInfo_ActivityLogAlertsEntry
  contacts?: ContactInfo[]
}

export interface AzureSubscriptionSecuritySettingInfo_ResourceGroupSettingsEntry {
  [key: string]: ResourceGroupSecuritySettings
}

export interface AzureSubscriptionSecuritySettingInfo_ActivityLogAlertsEntry {
  [key: string]: boolean
}

export interface ContactInfo {
  email?: string
  phone?: string
  alert_notifications?: boolean
  alerts_to_admins?: boolean
}

export interface DynamoDBTableInfo {
  common_info?: base.CommonInfo
  table_arn?: string
  creation_time?: string
  items_count?: string
  table_id?: string
  status?: string
  table_name?: string
  table_size_bytes?: string
  attributes?: string[]
}

export interface ElbInfo {
  common_info?: base.CommonInfo
  load_balancer_name?: string
  dns_name?: string
  canonical_hosted_zoneName?: string
  canonical_hosted_zoneNameID?: string
  policy_names?: string[]
  availability_zones?: string[]
  instance_ids?: string[]
  security_group_ids?: string[]
  vpc_id?: string
  subnet_ids?: string[]
  scheme?: string
  elb_data?: string
}

export interface AzureLoadBalancerInfo {
  common_info?: base.CommonInfo
  resource_id?: string
  nw_interfaces?: string[]
  health_probes?: string[]
  resource_group?: string
  load_balancing_rules?: string[]
  nat_rules?: string[]
}

export interface ResponseInfo {
  iam_info_list?: IAMInfo[]
  vpc_info_list?: VpcInfo[]
  sg_info_list?: SgInfo[]
  nacl_info_list?: NaclInfo[]
  instance_info_list?: InstanceInfo[]
  vpc_end_point_info_list?: VpcEndPointInfo[]
  subnet_info_list?: SubnetInfo[]
  route_table_info_list?: RouteTableInfo[]
  prefix_list_info_list?: PrefixListInfo[]
  s3_info_list?: S3Info[]
  kms_info_list?: KMSInfo[]
  scp_info_list?: SCPInfo[]
  account_data_info_list?: AccountDataInfo[]
  rds_info_list?: RDSInfo[]
  ebs_info_list?: EBSInfo[]
  lambda_info_list?: LambdaInfo[]
  dynamoDBTable_info_list?: DynamoDBTableInfo[]
  elb_info_list?: ElbInfo[]
  athena_info_list?: AthenaInfo[]
  elasticbeanstalk_info_list?: ElasticbeanstalkInfo[]
  glue_info_list?: GlueInfo[]
  sqs_info_list?: SQSInfo[]
  cloud_watch_metrics?: CloudWatchMetricInfo[]
  cloud_trails?: CloudTrailInfo[]
  config_services?: ConfigServiceInfo[]
  sns_topic?: SNSTopicInfo[]
  credential_report?: CredentialReportForUser[]
  role_assignments_info?: RoleAssignmentInfo[]
  storage_containers_info?: StorageContainerInfo[]
  storage_accounts_info?: StorageAccountInfo[]
  key_vaults_info?: KeyVaultInfo[]
  redis_cache_info?: RedisCacheInfo[]
  virtual_networks_info?: VirtualNetworkInfo[]
  azure_subnets_info?: AzureSubnetInfo[]
  azure_security_groups_info?: AzureSecurityGroupInfo[]
  azure_route_tables_info?: AzureRouteTableInfo[]
  azure_sql_databases_info?: AzureSQLDatabaseInfo[]
  azure_sql_server_info?: AzureSQLServerInfo[]
  azure_subscription_security_settings_info?: AzureSubscriptionSecuritySettingInfo[]
  key_vault_keys_info?: AzureKeyVaultKeyInfo[]
  key_vault_secrets_info?: AzureKeyVaultSecretInfo[]
  azure_vm_info?: AzureVMInfo[]
  azure_disk_info?: AzureDisksInfo[]
  azure_cosmos_db_info?: AzureCosmosDBInfo[]
  azure_service_principals_info?: AzureServicePrincipalInfo[]
  azure_function_apps_info?: AzureFunctionAppsInfo[]
  azure_loadbalancer_info?: AzureLoadBalancerInfo[]
  gcp_inventory_response_info?: string[]
  idp_info_list?: IDPInfo[]
  scopeInfo?: base.ScopeInfo[]
  gcp_response_info?: policyReaderGCP.GcpResponseInfo[]
}

export interface ValidateAccountResult {
  account_id?: string
  status?: base.AccountStatusEnum
  reason?: string
}

export interface InitiatePolicyGetInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  account_info?: base.AccountInfo[]
  retry?: boolean
}

export interface InitiatePolicyGetResp {
  resp_hdr?: base.RespHdr
  failed_status?: base.AccountStatus[]
}

export interface GetInventoryInternalReq {
  req_hdr?: base.ReqHdr
  ResourceType?: commonHdr.ResourceTypeEnum[]
  tenant_id?: string
  version?: number
  account_id?: string[]
  cloud_types?: string[]
}

export interface InventoryResp {
  resp_hdr?: base.RespHdr
  response?: ResponseInfo
}

export interface ValidateOrganizationReq {
  req_hdr?: base.ReqHdr
  organization_name?: string
  cloud_type?: base.CloudTypeEnum
  aws_organization_info?: base.AWSInfo
  azure_organization_info?: base.AzureInfo
  gcp_organization_info?: base.GCPAccountInfo
  okta_idp_info?: base.OktaInfo
  organization_uid?: string
  uid?: string
}

export interface ValidateOrganizationResp {
  resp_hdr?: base.RespHdr
  validate_type?: base.ValidateTypeEnum
  organization_info?: base.OrganizationInfo
  account_info?: base.AccountInfo
  message?: string
  error?: boolean
}

export interface AccountStatsInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface AccountSingleStat {
  ResourceType?: commonHdr.ResourceTypeEnum
  stat_name?: string
  stat_value?: number
}

export interface AccountStatsResp {
  resp_hdr?: base.RespHdr
  stats_list?: AccountSingleStat[]
}

export interface RecreateInventoryReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  version?: number
}

export interface RecreateInventoryResp {
  resp_hdr?: base.RespHdr
  response?: ResponseInfo
}

export interface ObjectProfileReq {
  req_hdr?: base.ReqHdr
  object_name?: string
  bucket_name?: string
  tenant_id?: string
  role_arn?: string
  external_id?: string
  region?: string
  account_id?: string
  cloud_type?: base.CloudTypeEnum
}

export interface ObjectProfileResp {
  resp_hdr?: base.RespHdr
  profile_name?: string
}

export interface GetResourceTypeEnumReq {
  req_hdr?: base.ReqHdr
}

export interface CredentialReportForUser {
  common_info?: base.CommonInfo
  id?: string
  user?: string
  password_enabled?: boolean
  password_last_used?: string
  password_last_changed?: string
  access_key_1_active?: boolean
  access_key_1_last_rotated?: string
  access_key_1_last_used_date?: string
  access_key_2_active?: boolean
  access_key_2_last_rotated?: string
  access_key_2_last_used_date?: string
  mfa_active?: boolean
  generated_time?: string
  arn?: string
}

export interface GetResourceTypeEnumResp {
  resp_hdr?: base.RespHdr
  resource_info?: base.ResourceInfo[]
}

export interface GetPoliciesReq {
  req_hdr?: base.ReqHdr
  policies?: string[]
  account_ids?: string[]
}

export interface GetPoliciesResp {
  resp_hdr?: base.RespHdr
  policies?: base.PolicyDetails[]
}

export interface GetPoliciesInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  policies?: string[]
  account_ids?: string[]
}

export interface GetPoliciesInternalResp {
  resp_hdr?: base.RespHdr
  policies?: base.PolicyDetails[]
}

export interface GetSubAccountsReq {
  req_hdr?: base.ReqHdr
  tenants?: commonHdr.TenantInfo[]
}

export interface GetSubAccountsResp {
  resp_hdr?: base.RespHdr
  updated_tenants?: commonHdr.TenantInfo[]
  accounts_changed?: boolean
}

export interface GetOrganizationIDReq {
  req_hdr?: base.ReqHdr
  service_account_json?: string
  domain?: string
  tenant_id?: string
}

export interface GetOrganizationIDResp {
  resp_hdr?: base.RespHdr
  organization_id?: string
}

export interface GetAzureUserEntitiesReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  account_info?: base.AccountInfo
}

export interface GetAzureUserEntitiesResp {
  resp_hdr?: base.RespHdr
  users_by_native_id?: GetAzureUserEntitiesResp_UsersByNativeIdEntry
}

export interface GetAzureUserEntitiesResp_UsersByNativeIdEntry {
  [key: string]: boolean
}

export interface BuildOrganizationHierarchyReq {
  req_hdr?: base.ReqHdr
  organization_name?: string
  cloud_type?: base.CloudTypeEnum
  organization_id?: string
  aws_organization_info?: base.AWSInfo
  azure_organization_info?: base.AzureInfo
  gcp_organization_info?: base.GCPAccountInfo
  organization_uid?: string
  uid?: string
}

export interface BuildOrganizationHierachyResp {
  resp_hdr?: base.RespHdr
  org_build_uuid?: string
}

export interface GetOrganizationHierarchyReq {
  req_hdr?: base.ReqHdr
  org_build_uuid?: string
}

export interface GetOrganizationHierarchyResp {
  resp_hdr?: base.RespHdr
  org_build_uuid?: string
  hierarchy_status?: OrganizationHierarchyStatusEnum
  organization_info?: base.OrganizationInfo
}

export enum DirectionEnum {
  DIRECTION_UNKNOWN = 'DIRECTION_UNKNOWN',
  DIRECTION_INBOUND = 'DIRECTION_INBOUND',
  DIRECTION_OUTBOUND = 'DIRECTION_OUTBOUND'
}

export enum OrgNodeType {
  NODE_TYPE_UNKNOWN = 'NODE_TYPE_UNKNOWN',
  ROOT = 'ROOT',
  ORGANIZATIONAL_UNIT = 'ORGANIZATIONAL_UNIT',
  ACCOUNT = 'ACCOUNT'
}

export enum OrganizationHierarchyStatusEnum {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}
